
    import { VirtualTrigger } from '@spectrum-web-components/overlay';
     
    const init = () => {
        const overlay = document.querySelector('sp-overlay');
        const popover = overlay.querySelector('sp-popover');
        
        // Set up the virtual trigger
        overlay.triggerElement = new VirtualTrigger(0, 0);
        
        // Set up change handler for menu items
        popover.addEventListener('change', (event) => {
            event.target.dispatchEvent(new Event('close', { bubbles: true }));
        });

        const handleContextmenu = async (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (overlay.triggerElement instanceof VirtualTrigger) {
                overlay.triggerElement.updateBoundingClientRect(
                    event.clientX,
                    event.clientY
                );
            }
            overlay.willPreventClose = true;
            overlay.open = true;
        };

        const root = document.getElementById('root');
        root.addEventListener('contextmenu', handleContextmenu, { capture: true });
    }

   customElements.whenDefined('code-example').then(() => {
        Promise.all([...document.querySelectorAll('code-example')].map(example => example.updateComplete)).then(() => {
            init();
        });
    });
